function UnderConstruction() {
  return (
    <div className='mx-auto w-50'>
      <img src='https://static.vecteezy.com/system/resources/previews/003/282/981/non_2x/under-construction-with-symbol-background-vector.jpg' />
    </div>
  )
}

export default UnderConstruction
